import { maxHeight, minHeight } from "@mui/system";

const styles = (theme) => ({
	container: {
		width: "100%",
		maxWidth: "100%",
		display: "flex",
	},

	paper: {
		padding: "16px",
		display: "flex",
		flexDirection: "row",
		gap: 1,
		justifyContent: "space-between",
		minHeight: "200px",
		width: "100%",

		flexGrow: 1,
	},

	titleDatagrid: {
		color: theme.palette.text.primary,
		fontWeight: 500,
		padding: "10px 20px",
		textAlign: "left",
	},
	paperDatagrid: {
		width: "100%",
		backgroundColor: theme.palette.background.paper,
		borderRadius: "16px",
		position: "relative",
		overflow: "hidden",
	},
	cardTitle: {
		fontWeight: 500,
		fontSize: "1rem",
	},
	cardText: {
		fontWeight: 500,
		fontSize: "24px",
		"@media (max-width: 600px)": {
			fontSize: "20px",
		},
		textWrap: "nowrap",
	},
	cardSubText: {
		fontWeight: 500,
		fontSize: "16px",
		mb: 0.4,
		"@media (max-width: 600px)": {
			fontSize: "16px",
			mb: 0.1,
		},
	},
	cardSubTextPie: {
		fontWeight: 500,
		fontSize: "12px",
		width: "100px",
		textWrap: "wrap",
		textAlign: "start",
		mb: 0.4,
		"@media (max-width: 600px)": {
			fontSize: "16px",
			mb: 0.1,
		},
	},
	cardSubText: {
		fontWeight: 500,
		fontSize: "16px",

		mb: 0.4,
		"@media (max-width: 600px)": {
			fontSize: "16px",
			mb: 0.1,
		},
	},
	littlePaper: {
		width: "100%",
		height: "180px",
		padding: "16px",
		display: "flex",
		flexDirection: "column",
		gap: "1rem",
		justifyContent: "center",
		gap: 1,
	},
	littleChart: {
		height: "50px",
		width: "",
	},
	boxPieChart: {
		display: "flex",
		width: "100%",
		height: "100%",
		position: "relative",
	},
	datagrid: {
		display: "grid",
		"&.MuiDataGrid-root": { borderStyle: "none" },

		// Reduz tamanho da fonte nas células
		"& .MuiDataGrid-cell": {
			fontSize: "0.75rem", // ou 12px
			py: "2px", // padding vertical reduzido
		},

		// Reduz tamanho da fonte nos títulos das colunas
		"& .MuiDataGrid-columnHeader": {
			fontSize: "0.75rem",
			py: "2px", // reduz altura do cabeçalho também
		},

		// Remove foco visual
		"& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus": {
			outline: "none !important",
		},

		'&.MuiDataGrid-root .MuiDataGrid-container--top [role="row"], & .MuiDataGrid-root .MuiDataGrid-container--bottom [role="row"]':
			{
				backgroundColor: "background.paper",
			},

		"& .super-app.positivo_ataque": {
			fontWeight: "600",
			animation: `${
				theme.palette.mode === "dark" ? "myEffectDark" : "myEffectLight"
			} 2.5s infinite`,
		},

		"@keyframes myEffectDark": {
			"0%, 100%": { color: theme.palette.secondary.main, fontWeight: "600" },
			"50%": { color: theme.palette.white.main, fontWeight: "600" },
		},
		"@keyframes myEffectLight": {
			"0%, 100%": { color: theme.palette.secondary.main, fontWeight: "600" },
			"50%": { color: theme.palette.black.main, fontWeight: "600" },
		},
	},
});

export default styles;
